import {
  RuleField,
  RuleOperator,
  ConditionJoin,
  FIELD_LABELS,
  OPERATOR_LABELS,
  CONDITION_JOIN_LABELS,
} from './ruleTypes'

export const FIELD_OPTIONS: { id: RuleField; text: string }[] = [
  { id: 'worksite_name', text: FIELD_LABELS.worksite_name },
  { id: 'worksite_location', text: FIELD_LABELS.worksite_location },
  { id: 'additional_info', text: FIELD_LABELS.additional_info },
  { id: 'title', text: FIELD_LABELS.title },
  { id: 'employment_type', text: FIELD_LABELS.employment_type },
  { id: 'employment_subtype', text: FIELD_LABELS.employment_subtype },
]

export const OPERATOR_OPTIONS: { id: RuleOperator; text: string }[] = [
  { id: 'equals', text: OPERATOR_LABELS.equals },
  { id: 'contains', text: OPERATOR_LABELS.contains },
  { id: 'not_contains', text: OPERATOR_LABELS.not_contains },
  { id: 'not_equals', text: OPERATOR_LABELS.not_equals },
  { id: 'is_any_of', text: OPERATOR_LABELS.is_any_of },
  { id: 'is_none_of', text: OPERATOR_LABELS.is_none_of },
]

export const JOIN_OPTIONS: { id: ConditionJoin; text: string }[] = [
  { id: 'and', text: CONDITION_JOIN_LABELS.and },
  { id: 'or', text: CONDITION_JOIN_LABELS.or },
]

/** First field choice not in `exclude` (avoid duplicate attributes across condition rows). */
export function firstFieldOtherThan(...exclude: RuleField[]): RuleField {
  const blocked = new Set(exclude)
  const found = FIELD_OPTIONS.find((o) => !blocked.has(o.id))
  return (found?.id ?? exclude[0]) as RuleField
}
